export const ROLES = {
    USER: 'ROLE_USER',
    VIEWER: 'USER_VIEWER'
};



// WEBPACK FOOTER //
// ./src/constants/user.js